import type { DirectoryPublic } from '@repo/types/directory';
import type { FilePublicWithPermissions } from '@repo/types/files';
import type { ReactNode } from 'react';

import FSEntitiesMenu from '@/components/features/files/FSEntitiesMenu';
import { ContextMenu, ContextMenuTrigger } from '@/components/ui/context-menu';
import { DropdownMenu } from '@/components/ui/dropdown-menu';
import { useEntityMenus } from '@/hooks/fs';
import { useMediaQuery } from '@/hooks/media-query';

interface FSEntityWrapperProps {
  entity: FilePublicWithPermissions | DirectoryPublic;
  entityType: 'file' | 'directory';
  children: ReactNode;
}

export default function FSEntityWrapper(fSEntityWrapperProps: FSEntityWrapperProps) {
  const { entity, entityType, children } = fSEntityWrapperProps;
  const breakpoint = useMediaQuery('sm');

  const { openDropdownMenu, handleOpenDropdownMenu, handleOpenContextMenu } = useEntityMenus({
    entity,
    entityType,
  });

  return (
    <ContextMenu onOpenChange={handleOpenContextMenu}>
      <DropdownMenu onOpenChange={handleOpenDropdownMenu} open={openDropdownMenu}>
        <ContextMenuTrigger disabled={!breakpoint} asChild>
          {children}
        </ContextMenuTrigger>
        <FSEntitiesMenu element={entity} type={entityType} showContextMenu={!breakpoint} showDropdownMenu={true} />
      </DropdownMenu>
    </ContextMenu>
  );
}
